import axios from "../interceptors/axios";

export default class UserService {
  list = async (params) => {
    try {
      const response = await axios.get("/api/users/list", { params });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  }

  create = async (data) => {
    try {
      const response = await axios.post("/api/users/create", data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  }

  update = async (data) => {
    try {
      const response = await axios.put("/api/users/update", data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  }

  updateBlogPublishPermission = async (userId, granted) => {
    try {
      const response = await axios.patch(`/api/admin/users/${userId}/permissions/blog-publish`, { granted });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  }

  delete = async (params) => {
    try {
      const response = await axios.delete("/api/users/delete", { params });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  }
}
